import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { GrnReturnDto } from './grn-return.dto';


export class GrnReturnResponseModel extends GlobalResponseObject {
    data?: GrnReturnDto[];

    /**
     * 
     * @param status 
     * @param errorCode 
     * @param internalMessage 
     * @param data 
     */
    constructor(status: boolean, errorCode: number, internalMessage: string, data?: GrnReturnDto[]) {
        super(status, errorCode, internalMessage);
        this.data = data;
    }
}

 